// removed by extract-text-webpack-plugin
module.exports = {"page":"_1QJ4M5joiJOARXxr3nBI5y","container":"_1B988bXRUucop3RuzQGN5O","carouselContainer":"_2HzEnVeauej2zcS-9xpz6x"};


//////////////////
// WEBPACK FOOTER
// ./src/components/GoogleDriveInstallation/GoogleDriveInstallation.css
// module id = 392
// module chunks = 0